import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query';
import { WagmiPlugin } from '@wagmi/vue';
import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';
import { createPinia } from 'pinia';
import type { App } from 'vue';
import { i18n } from '@src/app/i18n';
import { router } from '@src/app/router';
import { wagmiConfig } from '@src/shared/lib/web3/config';

const queryClient = new QueryClient();

export function registerPlugins(app: App) {
	app.use(createPinia());
	app.use(WagmiPlugin, { config: wagmiConfig, reconnectOnMount: true });
	app.use(VueQueryPlugin, { queryClient });
	app.use(i18n);
	app.use(router);
	app.use(FloatingVue);
}
